import { render, staticRenderFns } from "./4.Result.vue?vue&type=template&id=e2f718b4&scoped=true&"
import script from "./4.Result.vue?vue&type=script&lang=js&"
export * from "./4.Result.vue?vue&type=script&lang=js&"
import style0 from "./4.Result.vue?vue&type=style&index=0&id=e2f718b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f718b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2f718b4')) {
      api.createRecord('e2f718b4', component.options)
    } else {
      api.reload('e2f718b4', component.options)
    }
    module.hot.accept("./4.Result.vue?vue&type=template&id=e2f718b4&scoped=true&", function () {
      api.rerender('e2f718b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/訂單流程/4.Result.vue"
export default component.exports